<template>
  <v-app>
    <v-main>
      <table-page
        :headers="headers"
        :items="storageContainerBoxs"
        :rowCount="25"
      />
    </v-main>
  </v-app>
</template>
<script>
import TablePage from "../../../components/TablePage.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    TablePage,
  },
  methods: {
    ...mapActions(["getStorageContainerBoxs"]),
  },
  created() {
    this.getStorageContainerBoxs();
  },
  computed: {
    ...mapGetters(["currentInstitution", "storageContainerBoxs"]),
  },
  data() {
    return {
      headers: [
        {
          text: "Storage Container Drawer",
          value: "storageContainerDrawer.title",
        },
        {
          text: "Title",
          align: "start",
          value: "title",
        },
        { text: "Code", value: "code" },
        { text: "Rows", value: "rows" },
        { text: "Columns", value: "columns" },
        {
          text: "Position Labeling Option",
          value: "positionLabelingOption.title",
        },
        {
          text: "Row Labeling Schema",
          value: "rowLabelingSchema.title",
        },
        {
          text: "Column Labeling Schema",
          value: "columnLabelingSchema.title",
        },
      ],
      items: [],
    };
  },
};
</script>